"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemeItemApi = exports.SchemeItemApiFactory = exports.SchemeItemApiFp = exports.SchemeItemApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * SchemeItemApi - axios parameter creator
 * @export
 */
const SchemeItemApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get item gis information
         * @param {GetItemByIdsRequestParameters} [getItemByIdsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemEndpointGetItemGisInfo: (getItemByIdsRequestParameters_1, ...args_1) => __awaiter(this, [getItemByIdsRequestParameters_1, ...args_1], void 0, function* (getItemByIdsRequestParameters, options = {}) {
            const localVarPath = `/schemeitems/itemGisInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(getItemByIdsRequestParameters, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get items from scheme based on parameters
         * @param {GetItemsByTagsRequestParameters} [getItemsByTagsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemEndpointGetItemsByTag: (getItemsByTagsRequestParameters_1, ...args_2) => __awaiter(this, [getItemsByTagsRequestParameters_1, ...args_2], void 0, function* (getItemsByTagsRequestParameters, options = {}) {
            const localVarPath = `/schemeitems/itemsByTag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(getItemsByTagsRequestParameters, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get basic item information
         * @param {GetItemByIdsRequestParameters} [getItemByIdsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemEndpointGetSimplifiedItemsById: (getItemByIdsRequestParameters_2, ...args_3) => __awaiter(this, [getItemByIdsRequestParameters_2, ...args_3], void 0, function* (getItemByIdsRequestParameters, options = {}) {
            const localVarPath = `/schemeitems/simplifiedItemsById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(getItemByIdsRequestParameters, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get basic item information allong with the requested tags
         * @param {Array<string>} [type]
         * @param {GetItemsByTagsRequestParameters} [getItemsByTagsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemEndpointGetSimplifiedItemsBytag: (type_1, getItemsByTagsRequestParameters_2, ...args_4) => __awaiter(this, [type_1, getItemsByTagsRequestParameters_2, ...args_4], void 0, function* (type, getItemsByTagsRequestParameters, options = {}) {
            const localVarPath = `/schemeitems/simplifiedItemsBytag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type) {
                localVarQueryParameter['type'] = type;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(getItemsByTagsRequestParameters, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns whether the iten exists in the database
         * @param {string} schemeId
         * @param {Array<string>} [itemId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemEndpointItemExistsInDatabase: (schemeId_1, itemId_1, ...args_5) => __awaiter(this, [schemeId_1, itemId_1, ...args_5], void 0, function* (schemeId, itemId, options = {}) {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('schemeitemEndpointItemExistsInDatabase', 'schemeId', schemeId);
            const localVarPath = `/schemeitems/itemExists/{schemeId}`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (itemId) {
                localVarQueryParameter['itemId'] = itemId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SchemeItemApiAxiosParamCreator = SchemeItemApiAxiosParamCreator;
/**
 * SchemeItemApi - functional programming interface
 * @export
 */
const SchemeItemApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SchemeItemApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get item gis information
         * @param {GetItemByIdsRequestParameters} [getItemByIdsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemEndpointGetItemGisInfo(getItemByIdsRequestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeitemEndpointGetItemGisInfo(getItemByIdsRequestParameters, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemeItemApi.schemeitemEndpointGetItemGisInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get items from scheme based on parameters
         * @param {GetItemsByTagsRequestParameters} [getItemsByTagsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemEndpointGetItemsByTag(getItemsByTagsRequestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeitemEndpointGetItemsByTag(getItemsByTagsRequestParameters, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemeItemApi.schemeitemEndpointGetItemsByTag']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get basic item information
         * @param {GetItemByIdsRequestParameters} [getItemByIdsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemEndpointGetSimplifiedItemsById(getItemByIdsRequestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeitemEndpointGetSimplifiedItemsById(getItemByIdsRequestParameters, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemeItemApi.schemeitemEndpointGetSimplifiedItemsById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get basic item information allong with the requested tags
         * @param {Array<string>} [type]
         * @param {GetItemsByTagsRequestParameters} [getItemsByTagsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemEndpointGetSimplifiedItemsBytag(type, getItemsByTagsRequestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeitemEndpointGetSimplifiedItemsBytag(type, getItemsByTagsRequestParameters, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemeItemApi.schemeitemEndpointGetSimplifiedItemsBytag']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns whether the iten exists in the database
         * @param {string} schemeId
         * @param {Array<string>} [itemId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemEndpointItemExistsInDatabase(schemeId, itemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeitemEndpointItemExistsInDatabase(schemeId, itemId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemeItemApi.schemeitemEndpointItemExistsInDatabase']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.SchemeItemApiFp = SchemeItemApiFp;
/**
 * SchemeItemApi - factory interface
 * @export
 */
const SchemeItemApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SchemeItemApiFp)(configuration);
    return {
        /**
         * Get item gis information
         * @param {SchemeItemApiSchemeitemEndpointGetItemGisInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemEndpointGetItemGisInfo(requestParameters = {}, options) {
            return localVarFp.schemeitemEndpointGetItemGisInfo(requestParameters.getItemByIdsRequestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Get items from scheme based on parameters
         * @param {SchemeItemApiSchemeitemEndpointGetItemsByTagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemEndpointGetItemsByTag(requestParameters = {}, options) {
            return localVarFp.schemeitemEndpointGetItemsByTag(requestParameters.getItemsByTagsRequestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Get basic item information
         * @param {SchemeItemApiSchemeitemEndpointGetSimplifiedItemsByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemEndpointGetSimplifiedItemsById(requestParameters = {}, options) {
            return localVarFp.schemeitemEndpointGetSimplifiedItemsById(requestParameters.getItemByIdsRequestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Get basic item information allong with the requested tags
         * @param {SchemeItemApiSchemeitemEndpointGetSimplifiedItemsBytagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemEndpointGetSimplifiedItemsBytag(requestParameters = {}, options) {
            return localVarFp.schemeitemEndpointGetSimplifiedItemsBytag(requestParameters.type, requestParameters.getItemsByTagsRequestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns whether the iten exists in the database
         * @param {SchemeItemApiSchemeitemEndpointItemExistsInDatabaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemEndpointItemExistsInDatabase(requestParameters, options) {
            return localVarFp.schemeitemEndpointItemExistsInDatabase(requestParameters.schemeId, requestParameters.itemId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SchemeItemApiFactory = SchemeItemApiFactory;
/**
 * SchemeItemApi - object-oriented interface
 * @export
 * @class SchemeItemApi
 * @extends {BaseAPI}
 */
class SchemeItemApi extends base_1.BaseAPI {
    /**
     * Get item gis information
     * @param {SchemeItemApiSchemeitemEndpointGetItemGisInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeItemApi
     */
    schemeitemEndpointGetItemGisInfo(requestParameters = {}, options) {
        return (0, exports.SchemeItemApiFp)(this.configuration).schemeitemEndpointGetItemGisInfo(requestParameters.getItemByIdsRequestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get items from scheme based on parameters
     * @param {SchemeItemApiSchemeitemEndpointGetItemsByTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeItemApi
     */
    schemeitemEndpointGetItemsByTag(requestParameters = {}, options) {
        return (0, exports.SchemeItemApiFp)(this.configuration).schemeitemEndpointGetItemsByTag(requestParameters.getItemsByTagsRequestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get basic item information
     * @param {SchemeItemApiSchemeitemEndpointGetSimplifiedItemsByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeItemApi
     */
    schemeitemEndpointGetSimplifiedItemsById(requestParameters = {}, options) {
        return (0, exports.SchemeItemApiFp)(this.configuration).schemeitemEndpointGetSimplifiedItemsById(requestParameters.getItemByIdsRequestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get basic item information allong with the requested tags
     * @param {SchemeItemApiSchemeitemEndpointGetSimplifiedItemsBytagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeItemApi
     */
    schemeitemEndpointGetSimplifiedItemsBytag(requestParameters = {}, options) {
        return (0, exports.SchemeItemApiFp)(this.configuration).schemeitemEndpointGetSimplifiedItemsBytag(requestParameters.type, requestParameters.getItemsByTagsRequestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns whether the iten exists in the database
     * @param {SchemeItemApiSchemeitemEndpointItemExistsInDatabaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeItemApi
     */
    schemeitemEndpointItemExistsInDatabase(requestParameters, options) {
        return (0, exports.SchemeItemApiFp)(this.configuration).schemeitemEndpointItemExistsInDatabase(requestParameters.schemeId, requestParameters.itemId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SchemeItemApi = SchemeItemApi;
//# sourceMappingURL=scheme-item-api.js.map